import React from 'react';

import { Typography } from '@mui/material';
import { HeadCellFilterType } from 'components/Common/DataTable/DataTableTypes';
import { JBColors } from '@juliusbaer-gcrm/gcrm-frontend-components';
import { AdditionalAttendee } from 'types/ContactNote';

export const AdditionalAttendeeHeadcells: any = [
  {
    id: 'fullName',
    label: 'Full name',
    filter: HeadCellFilterType.SORT,
    color: JBColors.support.greenSmoke[80],
    width: '50%',
    render: function Render(row: AdditionalAttendee) {
      return <Typography> {row.fullName ?? '-'} </Typography>;
    },
  },
  {
    id: 'userId',
    label: 'User ID',
    filter: HeadCellFilterType.SORT,
    color: JBColors.support.greenSmoke[80],
    width: '50%',
    render: function Render(row: AdditionalAttendee) {
      return <Typography> {row.userId ?? '-'} </Typography>;
    },
  },
];
